import React, { HTMLProps } from 'react'
import type { ReactNode } from 'react'

type AnswersListProps = HTMLProps<HTMLParagraphElement>

// TODO: remove
export const AnswersText = (props: React.PropsWithChildren<AnswersListProps>): ReactNode => {
  return <p className="no-p-y-margin text-left wrap-break-word word-break-word" {...props} />
}
